import React from "react";
import { LuActivity as Activity } from "react-icons/lu";

import { ActivityPost } from "../../types/post.type";
// Activity Stats Component
type ActivityStatsProps = {
  activity: ActivityPost["activity"];
};

export const ActivityStats = ({ activity }: ActivityStatsProps) => {
  return (
    <div className="bg-gradient-to-r from-purple-50/80 to-blue-50/80 p-4 rounded-xl border border-purple-100">
      <div className="flex items-center gap-2 mb-3">
        <Activity className="h-5 w-5 text-purple-600" />
        <h4 className="font-semibold text-purple-900">Activity Stats</h4>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white/70 rounded-lg p-3 border border-purple-100">
          <div className="text-xs text-purple-600 font-medium mb-1">Scheduled Meetings</div>
          <div className="text-lg font-bold text-purple-900">{activity.scheduledMinutes} min</div>
        </div>
        <div className="bg-white/70 rounded-lg p-3 border border-blue-100">
          <div className="text-xs text-blue-600 font-medium mb-1">Direct Calls</div>
          <div className="text-lg font-bold text-blue-900">{activity.directCallMinutes} min</div>
        </div>
        {activity.aiLearningMinutes ? (
          <div className="bg-white/70 rounded-lg p-3 border border-emerald-100">
            <div className="text-xs text-emerald-600 font-medium mb-1">AI Learning</div>
            <div className="text-lg font-bold text-emerald-900">{activity.aiLearningMinutes} min</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
